import React, {Component} from 'react';
import swal from 'sweetalert';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import moment from 'moment';
import {Typeahead} from 'react-bootstrap-typeahead';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import {print} from 'react-icons-kit/fa/print';
import RaisedButton from 'material-ui/RaisedButton';
import ModalAuth from './modalAuth';
import { functionalCriterial, getDateHour, healthFacilities, healthFacilitiesOption, htmlTemplates, unitForTransfer, unitForTransferSt, unitTansfer, unitTransferAllSt, unitTransferConfirmUnit, unitTransferId, unitTransferUpdate } from '../../../libs/services';

var Config = require('../../../config');

class TransferForm extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searchComponent = this.searchComponent.bind(this);
		this.addComponent = this.addComponent.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.onPrintClick = this.onPrintClick.bind(this);
		this.getList = this.getList.bind(this);
		this.onChecked = this.onChecked.bind(this);
		this.onCheckAutConfirm = this.onCheckAutConfirm.bind(this);

		this.state = {
			send_options:[],
			send_by:"",
			destiny_options:[],
			destiny:"",
			destiny_name:"",
			shipping_date:"",
			shipping_time:"",
			shipping_user:"",
			messenger:"",
			shipping_temp:"",
			shipping_observations:"",
			unitsAdded:[],

			health_facilities:[],
			requestedSelected:[],
			indice:-1,
			isLoading: false,

			national_centers:[],
			requested2Selected:[],
			indice2:-1,

			unit_number:"",
			component_list:[],
			component:{},
			unitsSolicited:[],
			confirm:false,

			received_user: "",
		    received_date: "",
		    received_time: "",
		    received_temp: "",
		    received_observations:"",
		    unit_details:[],

		    finish:false,
		    id:"",
		    automatic:false,
		    reason:"",
		    auth_confirm:false,
			dis_auto_tras:{},
			totals:0
		}
	}

	async componentDidMount(){
		var user = JSON.parse(sessionStorage.getItem('medical_staff'));

		var name = ""
		if (user.names) {name += user.names};
		if (user.lastname1) {name += ' '+user.lastname1};
		if (user.lastname2) {name += ' '+user.lastname2};

		this.setState({
			shipping_user:  name,
			user_id:user.id,
			received_user:  name,
			user_received_id:user.id,
			send_by:sessionStorage.getItem("health_facilities_id"),
		});

		var response = await getDateHour();
		if(response){
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				shipping_date:date[2]+'-'+date[1]+'-'+date[0],
				shipping_time:hours,
				received_date:date[2]+'-'+date[1]+'-'+date[0],
				received_time:hours,
			});
		}

		this.getHealthFacilities();

		if(this.props.match.params.id !== undefined){
			this.setState({confirm:true});
			response = await unitTransferId(this.props.match.params.id);
			if(response !== undefined){
				var unit = [];
				response.detail.map((d)=>{
					unit.push({
						donation_number:d.unit_number,
						component_delivered:d.component,
						g_rh:d.g_rh,
						unit_confirm:d.unit_number_confirm,
						blood_component_confirm_id:d.blood_component_confirm_id,
						component_confirm:d.conponent_confirm,
						id:d.id,
						unit_transfer_id:this.props.match.params.id,
						unit_id:d.unit_id,
						checked:d.status === 'CONFIRMADA' ? true : false,
						disable_check:d.status === 'CONFIRMADA' ? true : false,
					})
				})

				this.setState({
					messenger: response.messenger,
					shipping_temp: response.shipping_temp,
					shipping_time: moment(response.shipping_time, 'H:mm:ss').format('HH:mm'),
					shipping_date:moment(response.shipping_date).format('YYYY-MM-DD'),
					shipping_user: response.user,
					shipping_observations:response.shipping_observations,
					unit_details:unit,						
					received_observations:response.received_observations,
					received_temp:response.received_temp
				})

				if(response.received_date !== null && response.received_date !== undefined){
					this.setState({
						received_date:moment(response.received_date).format('YYYY-MM-DD'),
						// received_time:moment(response.received_time, 'H:mm:ss').format('HH:mm'),
					})
				}
			}
		}

		response = await functionalCriterial('dis_auto_tras');
		if(response){
			this.setState({
				dis_auto_tras: response
			});

			if(response.value !== 'NO'){
				this.setState({auth_confirm:true});
			}
		}

		if(this.props.location.pathname === '/unit_transfer/automatic'){
			this.setState({automatic:true});

			this.getList();
		}
	}

	async getList(){
		var response = await unitForTransferSt(sessionStorage.getItem('health_facilities_id'));
		if(response !== undefined){
			response.map((res)=>{
				res.check = false;
			});

			this.setState({unitsAdded: response});
		}
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	async getHealthFacilities(){
		//traer hospitales
		var response = await healthFacilities();
		if(response){
			this.setState({
				health_facilities: response
			  });
			  
			  for (var i = 0; i < response.length; i++) {
				  if (response[i].id == this.state.send_by) {
					  
					  this.setState({
						  indice:i,
							requestedSelected: [response[i]],
					  });
				  };
  
			  };
			  this.getNationalCenters();
		}
	} 

	_handleSearch = (query) => {
	    this.setState({
			indice:-1,
			requestedSelected:[],
	    });
	}

	_handleSearch2 = (query) => {
	    this.setState({
			indice2:-1,
			requested2Selected:[],
	    });
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	if(name === 'component'){
        		this.setState({
		            [name]: values[0]
		        });

		        setTimeout(()=>{
		        	if(this.state.confirm){
		        		this.confirmComponent(values[0]);
		        	}else{
		        		this.addComponent();
		        	}
		        	
		        }, 500);
        	}else{
        		this.setState({
		            [name]: values[0].id
		        });

		        if (name === 'send_by') {
		        	this.setState({
						indice:0,
						requestedSelected:values,
				    });
		        };

		        if (name === 'destiny') {
		        	this.setState({
						indice2:0,
						requested2Selected:values,
				    });

				    //document.getElementById('date_form').focus();
		        };
        	}
        	
        }
    }

	async getNationalCenters(){
		//fetch(Config.default.apiGateway.URL+'national_centers/exclude_itsame?health_facilities_id='+sessionStorage.getItem("health_facilities_id"),{ 
		var response = await healthFacilitiesOption('principal');
		if(response !== undefined){
			this.setState({
				destiny: response[0].id,
				destiny_name:response[0].name
			})
		}
	}

	handleChange(e){
		var campo = e.target.name;

		this.setState({
			[campo] : e.target.value
		});

		if(campo === 'shipping_time'){
			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		}else{
			setTimeout(()=>{
				this.showCtrlError(campo);
			}, 500)
		}	
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	async searchComponent(e){
		if(e.key === 'Enter' || e.key === undefined){
			e.preventDefault();
			var number = e.target.value === undefined ? this.state.unit_number : e.target.value;
			var api = '';
			var response;
			if(this.state.confirm){
				//api = 'unit_transfer/confirm_unit?health_facilities_id='+sessionStorage.getItem('health_facilities_id')+'&unit_number='+number;
				response = await unitTransferConfirmUnit(sessionStorage.getItem('health_facilities_id'), number);
			}else{
				//api = 'units/unit_for_transfer?number='+number+'&health_facilities_id='+sessionStorage.getItem('health_facilities_id');
				response = await unitForTransfer(number, sessionStorage.getItem('health_facilities_id'));
				//api = 'units/send_unit?health_facilities_id='+sessionStorage.getItem('health_facilities_id')+'&unit_number='+e.target.value;
			}

			if(response !== undefined){
				if(response.length > 0){
					response.map((res)=>{
						res.label = res.code + ' ' +res.component_number
					})

					this.setState({
						component_list: response,
						component:response[0]
					})

					setTimeout(()=>{
						if(this.state.confirm){
							this.confirmComponent(response[0]);
						}else{
							this.addComponent();
						}
						
					}, 500);
				}else{
					swal('Error', 'La unidad no se encuentra en el listado de unidades recibidas', 'error');
					
				}
			}

		}
	}

	removeUnitFromList = (indice) => {
		var array = [...this.state.unitsAdded];
		array.splice(indice, 1);
		this.setState({unitsAdded: array});	
	}

	addComponent(){
		var repeated = false;
		var validComponent = false;

		if (this.state.unit_number !== "" && this.state.component.length !== 0 ) {
			var index = this.state.unitsSolicited.findIndex(obj => obj.component_type === this.state.component.blood_component.component_type);
			
			if(index === -1){
				validComponent = true;
			}

			for (var i = 0; i < this.state.unitsAdded.length; i++) {
				if(this.state.unitsAdded[i].unit_id === this.state.component.id &&
					this.state.unitsAdded[i].component_id === this.state.component.blood_component_id){
					repeated = true;
				}
			};

			//if(this.state.component.status === 'DISPONIBLE' || this.state.dis_unit_cad.value === 'YES'){
				if (repeated === true) {
					swal('¡La unidad no se puede agregar!', '¡Ya se ingreso esa unidad!', 'error');
				}else {
					var obj = {}
					obj.unit_id = this.state.component.id;
					obj.component_id = this.state.component.blood_component_id;
					obj.donation = this.state.component.unit_number;
					obj.component = this.state.component.component;
					obj.component_type = this.state.component.component_type;
					obj.group = this.state.component.group;
					obj.rh = this.state.component.rh;
					obj.volume = this.state.component.volume;
					obj.component_number = this.state.component.component_number;
					
					this.setState({ 
						unitsAdded: [...this.state.unitsAdded, obj],
						unit_number:"",
						component:{},
						component_list:[],
					});

					//this._typeahead_component.getInstance().clear();
					document.getElementById('unit_number').classList.remove('error');
					document.getElementById('unit_number').focus();

				};	
		}
	}

	confirmComponent(val){
		
		var index = this.state.unit_details.findIndex(obj =>
			obj.unit_id === val.id
		);

		if(index !== -1){
			this.state.unit_details[index].unit_confirm = val.unit_number;
			this.state.unit_details[index].component_confirm = val.component;
			this.state.unit_details[index].blood_component_confirm_id = val.blood_component_id;
			this.state.unit_details[index].checked = true;
			this.forceUpdate();

			this.setState({ 
				unit_number:"",
				component:{},
				component_list:[],
			});

			//this._typeahead_component.getInstance().clear();
			document.getElementById('unit_number').classList.remove('error');
			document.getElementById('unit_number').focus();
		}else{
			swal('Error', 'La unidad y componente no fueron solicitados', 'error');
		}
	}

	onCancel(){
		this.props.history.push("/unit_transfer");
	}

	async confirmSave(service, id, object){
		var response;
		if(id !== null){
			response = await service(id, object);
		}else{
			response = await service(object);
		}

		if(response !== undefined){
			swal("Correcto", "Registro guardado correctamente.", 'success');
			this.setState({finish:true});
			if(!this.state.confirm){
				this.setState({id:response.id});
			}
		}
		
	}

	onSave(){
		//this.waiting_modal.handleShow('Guardando...');
		var service;
		var id = null
		if(this.isValidDate(this.state.shipping_date)){
			if(this.isValidForm()){
				var date = moment(this.state.shipping_date.split('-').reverse().join('/'), 'DD-MM-YYYY');
				var hour = moment(this.state.shipping_time, 'h:mm a');
				var date_res = moment(this.state.received_date.split('-').reverse().join('/'), 'DD-MM-YYYY');
				var hour_res = moment(this.state.received_time, 'h:mm a');
				var object = {};
				var apiUrl = '';
				var valid = false;
				var method = 'post';
				
				if(this.state.confirm){
					method = 'put';
					object = {
						id:this.props.match.params.id,
						send_by: this.state.send_by,
				        destiny: this.state.destiny,
				        shipping_user: this.state.user_id,
				        messenger: this.state.messenger,
				        shipping_date: date.format('MM-DD-YYYY'),
				        shipping_time: this.state.shipping_time.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm'),
				        shipping_temp: this.state.shipping_temp,
				        shipping_observations: this.state.shipping_observations,
				        received_user: this.state.user_received_id,
					    received_date: date_res.format('MM-DD-YYYY'),
					    received_time: this.state.received_time.indexOf('-') !== -1 ? "Invalid date" : hour_res.format('H:mm'),
					    received_temp: this.state.received_temp,
					    received_observations: this.state.received_observations,
					    unit_transfer_detail:[],
					};

					var confirm = 0;
					var pending = 0
					this.state.unit_details.map((u)=>{
						if(u.checked && !u.disable_check){
							object.unit_transfer_detail.push({
					            id:u.id,
					            unit_transfer_id:u.unit_transfer_id,
					            unit_id:u.unit_id,
					            unit_number_confirm: u.unit_confirm,
					            blood_component_confirm_id: u.blood_component_confirm_id
					        });

					        pending++;
						}

						if(u.disable_check){
							confirm++;
						}				
					})

					if(pending+confirm === this.state.unit_details.length  ){
						valid = true;
					}

					if(this.state.auth_confirm){
						service = unitTransferAllSt;
						id = this.props.match.params.id;
						//apiUrl = 'unit_transfer/all_st/'+this.props.match.params.id;
					}else{
						//apiUrl = 'unit_transfer/'+this.props.match.params.id;	
						service = unitTransferUpdate;
						id = this.props.match.params.id;
					}
					

				}else{
					object = {
						transfer: {
					        send_by: this.state.send_by,
					        destiny: this.state.destiny,
					        shipping_user: this.state.user_id,
					        messenger: this.state.messenger,
					        shipping_date: date.format('MM-DD-YYYY'),
					        shipping_time: this.state.shipping_time.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm'),
					        shipping_temp: this.state.shipping_temp,
					        shipping_observations: this.state.shipping_observations
					    },
					    units: []
					};

					if(this.state.automatic){
						//apiUrl = 'unit_transfer';
						service = unitTansfer;

						object.transfer.reason = this.state.reason;

						this.state.unitsAdded.map((u)=>{
							if(u.check){
								object.units.push(u.id);	
							}							
						});

						if(this.state.unitsAdded.length === object.units.length){
							valid = true;
						}else{
							if(object.transfer.reason !== ""){
								valid = true;
							}
						}



					}else{
						//apiUrl = 'unit_transfer';
						service = unitTansfer;

						this.state.unitsAdded.map((u)=>{
							object.units.push(u.unit_id);
						});

						
						if(this.props.match.params.id !== undefined){
							object.id = this.props.match.params.id;
						}

						if(object.units.length > 0){
							valid = true;
						}
					}

						
				}

				if(valid){
					this.confirmSave(service, id, object);
				}else{
					if(this.state.automatic){
						if(object.units.length > 0){
							this.modal_auth.handleShow();
						}else{
							swal('Error', 'Debe ingresar por lo menos una unidad', 'error');
						}
						
					}else{
						if(this.state.confirm){
							//if(pending > confirm){
								swal({
							        title: '¿Está seguro?',
							        text: '¿Existen unidades sin confirmar, desea continuar?',
							        type: 'warning',
							        showCancelButton: true,
							        confirmButtonColor: '#DD6B55',
							        confirmButtonText: '¡Si, Continuar!',
							        cancelButtonText: '¡No, Cancelar!',
							        closeOnConfirm: true,
							        closeOnCancel: true
							    }, (isConfirm)=> {
							        if (isConfirm) {
							        	this.confirmSave(service, id, object);
							        }
							    });
							/*}else{
								swal('Error', 'Debe confirmar por lo menos una unidad', 'error');
							}*/
							
						}else{
							swal('Error', 'Debe ingresar por lo menos una unidad', 'error');
						}
					}
						
					
				}
			}else{

				swal("¡Error!", "Campos Incompletos", 'error');
			}
		}else{
			swal('Error', 'Fecha no válida','error');
		}
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
    			const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}		   
		  	}
	    });
	    
	    return isFormValid;
	}

	isValidDate(fecha){
		var valid = moment(fecha).format('MM-DD-YYYY');

		if(valid === 'Invalid date'){
			return false;
		}else{
			return true;
		}
	}

	async onPrintClick(e){
		e.preventDefault();

		var id = this.props.match.params.id !== undefined ? this.props.match.params.id : this.state.id;

		var response = await htmlTemplates(sessionStorage.getItem("health_facilities_id"), 'AREA_DISTRIBUTION');
		if(response !== undefined){
			if(response.res === 0){
				swal('¡Error!', "No se ha definido ningún formato de impresión", 'error');
			}else{
				this.props.waiting.handleShow('Imprimiendo...');
				
				var obj ={};
				obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
				obj.id = id;
				obj.file_type = "transfer_units";
				obj.nEtiqueta = [0];

				var type = await this.props.getDocumentType(obj.file_type);

				var document;
				if(type !== undefined){
					if(type.print_type === 'template'){
						document = await this.props.printDocumentTemplate(obj, type.print_automatically);
					}else if(type.print_type === 'external'){
						document = await this.props.printDocumentExternal(obj, type.print_automatically);
					}
				}
				
				this.props.waiting.handleClose();		
				
			}
		}		
	}

	onChecked(e){
		if(e.target.id === 'check_all'){
			var units = this.state.unitsAdded;
			
			units.map((u)=>{
				u.check = e.target.checked ? true : false;
			});

			this.setState({
				check_all:e.target.checked ? true : false, 
				unitsAdded:units,
				totals: e.target.checked ? units.length : 0
			});
		}else{
			var units = this.state.unitsAdded;
			var totals = this.state.totals;

			units.map((u)=>{
				if(u.id === parseInt(e.target.id)){
					u.check = e.target.checked ? true : false;

					if(u.check){
						totals++;
					}else{
						totals--;
					}
				}
				
			});

			this.setState({unitsAdded:units, totals: totals});
		}
	}

	onCheckAutConfirm(e){
		
		if(e.target.id === 'check_all'){
			this.setState({check_all:e.target.checked ? true : false});
		}

		var units = this.state.unit_details;

		units.map((unit)=>{
			if(e.target.id === 'check_all'){
				unit.checked = e.target.checked ? true : false;
			}else{
				if(unit.id === parseInt(e.target.id)){
					unit.checked = e.target.checked ? true : false;
				}
			}
		});

		this.setState({unit_details: units});
		
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.distribution.MAIN')} ->
						Registro Traspaso Unidades
					</h5>
				</div>

				<form noValidate>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-4">
							<span className="span-min">Centro Distribuidor</span>
							<AsyncTypeahead
					          	labelKey={(option) => `${option.name}`}
					          	minLength={0}
					          	inputProps={{
					          		name:"send_by",
					          		required:true,
					          		id:"send_by"
					          	}}
					          	id="sendBy"
					          	disabled={true}
					          	options={this.state.health_facilities}
					          	onChange={this.handleTypeAheadChange('send_by')}
					          	onSearch={this._handleSearch}
					          	defaultSelected={this.state.health_facilities.slice(this.state.indice, 1)}
					          	selected={this.state.requestedSelected}
					          	ref={ref => this._typeahead = ref}
					          	useCache={false}
					          	isLoading={this.state.isLoading}
					          	delay={600}
					        />
						</div>

						<div className="col-xs-12 col-sm-4">
							<span className="span-min">Centro Estatal</span>
					        <input name="destiny_name" value={this.state.destiny_name} disabled className="form-control" />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Envio</span>
							<input className="form-control hour-input" name="shipping_date" id="shipping_date" type="date" 
								value={this.state.shipping_date || ""} onChange={this.handleChange} disabled />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Hora Envio</span>
							<input id="shipping_time" name="shipping_time" type="text" data-inputmask-alias="datetime" 
								data-inputmask-inputformat="HH:MM"  data-inputmask-placeholder="-" 
								value={this.state.shipping_time || ""} onChange={this.handleChange}
								disabled className="form-control"/>
						</div>
					</div>

					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-4">
							<span className="span-min">Usuario Envía</span>
							<input className="form-control" disabled name="shipping_user" id="shipping_user" value={ this.state.shipping_user } onChange={ this.handleChange } required/>
						</div>

						<div className="col-xs-12 col-sm-4">
							<span className="span-min">Mensajero</span>
							<input className="form-control" name="messenger" id="messenger" value={ this.state.messenger } 
								onChange={ this.handleChange } disabled={this.state.confirm}/>
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Temperatura de Salida</span>
							<input className="form-control" name="shipping_temp" id="shipping_temp" 
								value={ this.state.shipping_temp } onChange={ this.handleChange } disabled={this.state.confirm} required/>
						</div>
					</div>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-8">
							<span className="span-min">Observaciones</span>
							<textarea className="form-control" name="shipping_observations" value={ this.state.shipping_observations || "" } 
								style={{resize:"none"}} onChange={ this.handleChange } disabled={this.state.confirm}/>
						</div>
					</div>
					
					{this.state.confirm ?
						<div>
							<div className="col-xs-12 form-group">
								<div className="col-xs-12 col-sm-4">
									<span className="span-min">Usuario Recibe</span>
									<input className="form-control" disabled name="received_user" id="received_user" value={ this.state.received_user } onChange={ this.handleChange } required/>
								</div>
								<div className="col-xs-12 col-sm-2 col-sm-offset-4">
									<span className="span-min">Fecha Recibo</span>
									<input className="form-control hour-input" name="received_date" id="received_date" type="date" 
										value={this.state.received_date || ""} onChange={this.handleChange} disabled />
								</div>
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">Hora Recibo</span>
									<input id="received_time" name="received_time" type="text" data-inputmask-alias="datetime" 
										data-inputmask-inputformat="HH:MM"  data-inputmask-placeholder="-" 
										value={this.state.received_time || ""} onChange={this.handleChange}
										disabled className="form-control"/>
								</div>
							</div>
							<div className="col-xs-12">
								<div className="col-xs-12 col-sm-8">
									<span className="span-min">Observaciones al confirmar unidades</span>
									<textarea className="form-control" name="received_observations" value={ this.state.received_observations } 
										style={{resize:"none"}} onChange={ this.handleChange } />
								</div>
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">Temperatura de llegada</span>
									<input className="form-control" name="received_temp" id="received_temp" 
										value={ this.state.received_temp } onChange={ this.handleChange } required/>
								</div>
							</div>
						</div>
					:null}
					
					<hr style={{width:'100%'}} />
					<fieldset>
						<legend>{!this.state.confirm ? 'Unidades enviar' : 'Confirmar Unidades Recibidas'}</legend>
						{!this.state.automatic && !this.state.auth_confirm?
							<div className="col-xs-12 form-group">
								<div className="col-xs-12 col-sm-4">
									<span className="span-min">No. Unidad</span>
									<input type="text" name="unit_number" id="unit_number"  
										onChange={this.handleChange} value={this.state.unit_number || ""} 
										onKeyPress={this.searchComponent}
										className={"form-control"} />
								</div>
								<div className="col-xs-12 col-sm-1">
									<FloatingActionButton className="action-btn" iconStyle={{height: 25, width: 25}} mini={true} style={{marginTop: 18 }} 
										//onClick={!this.state.confirm ? /*this.addComponent*/ this.searchComponent : this.confirmComponent}>
										onClick={this.searchComponent}>
				                      <ContentAdd/>
				                    </FloatingActionButton> 
								</div>
							</div>
						:null}

						{!this.state.automatic ?
							<div className="col-xs-12 form-group">
								<div className="col-xs-12 form-group">
									<label>Total de unidades:  </label>
									<span style={{marginLeft:'5px'}}>
										{'  '+!this.state.confirm ? this.state.unitsAdded.length : this.state.unit_details.length}
									</span>
								</div>
								<div className="col-xs-12 col-sm-8">
									<Table responsive hover>
										<thead>
											{!this.state.confirm ?
												<tr>
													<th>No. Donación</th>
													<th>Componente Sanguíneo</th>
													<th>No. Componente</th>
													<th>Grupo & RH</th>
													<th>Volumen</th>
													<th></th>
												</tr>
											: <tr>
													<th>No. Donación</th>
													<th>Componente Sanguíneo</th>
													<th>Grupo & RH</th>
													{!this.state.auth_confirm ? <th>No. Unidad Confirmada</th> : null}
													{/*<th>Componente Confirmado</th>*/}
													<th style={{textAlign: "center"}}>
														{this.state.auth_confirm ?
															<input type="checkbox" id="check_all" 
																value={this.state.check_all} 
																onChange={this.onCheckAutConfirm}
																checked={this.state.check_all} />
														:null}
													</th>
												</tr>}
												
										</thead>
										<tbody>
						                {!this.state.confirm ?
						                	this.state.unitsAdded.map( (unit, index) => (
							                    <tr key={index}>
							                      	<td>{unit.donation}</td>
							                      	<td>{unit.component}</td>
							                      	<td>{unit.component_number}</td>
							                      	<td>{unit.group + (unit.rh === 'POSITIVO' ? '+' : unit.rh === 'NEGATIVO' ? '-' : '')} </td>
							                      	<td>{unit.volume}</td>
							                      	<td width={60} style={{textAlign: "center",padding: "2px",}}>
							                        	<button className="btn btn-info btn-xs" title="Eliminar" style={{marginRight:'3px'}} 
							                        		onClick={(e) => this.removeUnitFromList(index, e)}>
							                            	<SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
							                        	</button>
							                      	</td>
							                    </tr>
							                ))
						               	:null}
						               	{this.state.confirm ?
						               		this.state.unit_details.map( (unit, index) => (
							                    <tr key={index}>
							                      	<td>{unit.donation_number}</td>
							                      	<td>{unit.component_delivered}</td>
							                      	<td>{unit.g_rh}</td>
							                      	{!this.state.auth_confirm ?
							                      		<td>
							                      			<input className="form-control" value={unit.unit_confirm} disabled/>
							                      		</td>
							                      	:null}
							                      	{/*<td>
							                      		<input className="form-control" value={unit.component_confirm} disabled/>
							                      	</td>*/}
							                      	<td style={{textAlign: "center"}}>
							                        	<input type="checkbox" value={unit.checked} 
							                        		id={unit.id}
							                        		checked={unit.checked} 
							                        		disabled={unit.disable_check} 
							                        		onChange={this.state.auth_confirm ? this.onCheckAutConfirm : (e)=>e.preventDefault()}/>
							                      	</td>
							                    </tr>
							                ))
						               	:null}
						                </tbody>
									</Table>
								</div>
								
							</div>
						: <div className="col-xs-12 form-group">
							<div className="col-xs-12 form-group">
								<label>Total de unidades:  </label>
								<span style={{marginLeft:'5px'}}>
									{'  '+this.state.totals}
								</span>
							</div>
							<div className="col-xs-12 col-sm-8">
								<Table responsive hover>
									<thead>
										<tr>
											<th>
												<input type="checkbox" id="check_all" checked={this.state.check_all} 
													value={this.state.check_all} onChange={this.onChecked} />
											</th>
											<th>Componente Sanguíneo</th>
											<th>No. Unidad</th>
											<th>No. Componente</th>
											<th>Grupo & RH</th>
											<th>Volumen</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										{this.state.unitsAdded.map((unit, i)=>(
											<tr key={i}>
												<td>
													<input type="checkbox" id={unit.id} onChange={this.onChecked} value={unit.check}
														checked={unit.check} />
												</td>
						                      	<td>{unit.component}</td>
						                      	<td>{unit.unit_number}</td>
						                      	<td>{unit.component_number}</td>
						                      	<td>{unit.group + (unit.rh === 'POSITIVO' ? '+' : unit.rh === 'NEGATIVO' ? '-' : '')} </td>
						                      	<td>{unit.volume}</td>
						                      	<td width={60} style={{textAlign: "center",padding: "2px",}}>
						                        
						                      	</td>
											</tr>
										))}
									</tbody>
								</Table>
							</div>
						</div>}
					</fieldset>
					
					{parseInt(sessionStorage.getItem('health_facilities_id')) !== this.state.destiny ?
						<div className="col-xs-12 form-group" style={{textAlign:'center'}}>
							<button className="toolIcon" onClick={this.onPrintClick} 
								disabled={this.props.match.params.id !== undefined ? false : this.state.id !== "" ? false : true}>
								<SvgIcon size={40} icon={print} />
								<div><span>Imprimir</span></div>
							</button>
						</div>
					: null}
					<div className="col-xs-12" style={{textAlign:'center'}}>
			        	<div>
			        		{this.state.finish ?
			        			<RaisedButton className="action-btn" label={t('content.generics.buttons.finish')} primary={true} onClick={this.onCancel}  style={{margin:12}}/>
			        		: <RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave}  style={{margin:12}}/>}
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onCancel}/>
			        	</div>
			        </div>
						
				</form>

				<ModalAuth {...this.props} handleChange={this.handleChange} reason={this.state.reason} 
					onRef={ref => (this.modal_auth = ref)} onSave={this.onSave} />
			</div>
		)
	}
}
export default translate('translations')(TransferForm);